import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CONTEXTUAL_PROMOTION_BUTTONS_BANDIT_CONFIG = createFcmDetails(
	'contextual_promotion_buttons_bandit_config',
	{
		owner: 'Monetization',
		context: 'promotion page',
		import: false,
		description: `
Used to configure the buttons amounts for the promote page, based on the variant coming from the contextual_promotion_buttons bandit
`,
		template: {
			v1: [10, 20, 30, 40],
			v2: [20, 40, 60],
			v3: [20, 30, 50, 60],
			v4: [10, 50],
			v5: [60, 70, 80],
		},
	},
);
